module.exports = __webpack_public_path__ + "fonts/Latinka-ExtraLight.b55ff2a5.ttf";